import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls back to the top on every route (pathname) change.
 * Covers both the window and any inner scroll containers used by the
 * layouts (e.g. the agent layout's <main className="overflow-auto">).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Reset any scrollable content containers
    document.querySelectorAll('main, #content, #content-wrapper').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
